import styled from "styled-components";

export const SlideoutWrapper = styled.div`
  & [data-slideout],
  & > div {
    transition: transform 0.15s ease-in-out !important;
  }
`;

export const DocumentDetailSlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const DocumentDetailSlideoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const DocumentDetailSlideoutTabs = styled.div`
  margin-bottom: 24px;

  /* Tablist siempre en fila */
  &[data-tabs] [role="tablist"],
  & [role="tablist"] {
    display: flex;
    width: 100%;
    gap: 0;
  }

  /* Cada tab ocupa 50% y centra su contenido */
  & button[role="tab"] {
    flex: 1 1 50%;
    justify-content: center;
    text-align: center;
  }
`;

export const DocumentDetailSlideoutContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const AccessList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AccessItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const AccessBullet = styled.span`
  width: 4px;
  height: 4px;
  background-color: ${(props) => props.theme.colors.grey};
  border-radius: 50%;
  margin: 0 8px;
`;

export const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  /* Si necesitas empujar el último elemento (p.ej. un Tag) al extremo derecho: */
  & > *:last-child {
    margin-left: auto;
  }
`;

export const TagGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TagsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  & > *:last-child {
    margin-left: auto;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
  flex-wrap: wrap;
`;

export const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 32px;
`;

export const SummaryContent = styled.div``;

export const PreviewContainer = styled.div`
  width: 100%;
  height: 80px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.brightGray};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PreviewImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;

export const PreviewButton = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
`;

export const ActivityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 32px;
`;

export const ActivityItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ActivityItemDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  & > ul.item-list {
    padding-left: 30px;
    margin: 0;
    line-height: 32px;
  }
`;

export const ActivityItemDetailList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
